export default  {"src":"/_next/static/image/public/images/icon_sm_money.6e1e77b3ecdc3d64aacad2986bb9ad2e.svg","height":20,"width":24};